import { useCallback, useState } from 'react';
import cn from 'classnames';
import { ClickableIcon } from '@direct-frontend/components';
import { getSnowflakesAvailability, toggleSnowflakes } from '../Snowflakes';
import { getSnowflakesVisibility } from '../Snowflakes';
import styles from './SnowflakesButton.module.css';

const isSnowflakesAvailable = getSnowflakesAvailability();

export const SnowflakesButton = ({ className }: { className?: string }) => {
    const [isVisible, setIsVisible] = useState(getSnowflakesVisibility());

    const handleClick = useCallback(() => {
        toggleSnowflakes();
        setIsVisible(!isVisible);
    }, [isVisible]);

    if (!isSnowflakesAvailable) {
        return null;
    }

    return (
        <div title={isVisible ? 'Отключить снежинки' : 'Включить снежинки'} className={cn(styles.root, className)}>
            <ClickableIcon
                className={cn(styles.icon, isVisible && styles.icon_visible)}
                role="main"
                onClick={handleClick}
            >
                {isVisible ? <SnowflakeFilledIcon /> : <SnowflakeIcon />}
            </ClickableIcon>
        </div>
    );
};

/* Inline icon для корректной работы отображения цвета иконки */
const SnowflakeFilledIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1m0 1.5a.58.58 0 0 0-.57.495l-.288 2.014-1.956-1.117a.458.458 0 0 0-.526.745l2.389 2.048.296 4.183-3.473-2.35-.578-3.092a.458.458 0 0 0-.908.082L6.375 7.76l-1.888-.758a.577.577 0 0 0-.571.99l1.6 1.255-1.945 1.136a.458.458 0 0 0 .383.827l2.967-1.045 3.773 1.833-3.773 1.834-2.967-1.044a.458.458 0 0 0-.383.827l1.946 1.135-1.601 1.257a.577.577 0 0 0 .571.99l1.888-.76.01 2.254a.458.458 0 0 0 .909.082l.578-3.093 3.474-2.351-.297 4.184-2.389 2.05a.459.459 0 0 0 .526.744l1.956-1.118.288 2.015a.577.577 0 0 0 1.141 0l.287-2.015 1.957 1.118a.458.458 0 0 0 .526-.745l-2.39-2.049-.3-4.186 3.477 2.353.579 3.093a.459.459 0 0 0 .908-.082l.01-2.254 1.889.76a.577.577 0 0 0 .57-.99l-1.6-1.257 1.946-1.135a.458.458 0 0 0-.383-.827l-2.968 1.044-3.775-1.834 3.775-1.833 2.968 1.045a.459.459 0 0 0 .383-.827l-1.947-1.136 1.601-1.256a.578.578 0 0 0-.57-.99l-1.889.759-.01-2.253a.459.459 0 0 0-.908-.082l-.58 3.092-3.476 2.353.3-4.186 2.39-2.048a.459.459 0 0 0-.526-.745l-1.957 1.117-.287-2.014A.58.58 0 0 0 12 2.5" />
    </svg>
);

/* Inline icon для корректной работы отображения цвета иконки */
const SnowflakeIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2.5c.287 0 .53.211.57.495l.288 2.014 1.957-1.117a.458.458 0 0 1 .525.745l-2.39 2.048-.3 4.186 3.478-2.353.579-3.092a.458.458 0 0 1 .908.082l.01 2.253 1.888-.758a.577.577 0 0 1 .57.99l-1.6 1.255 1.946 1.136a.458.458 0 0 1-.383.827l-2.967-1.045-3.776 1.833 3.776 1.834 2.967-1.044a.458.458 0 0 1 .383.827l-1.946 1.135 1.6 1.257a.577.577 0 0 1-.57.99l-1.888-.76-.01 2.254a.459.459 0 0 1-.908.082l-.58-3.093-3.476-2.353.299 4.186 2.39 2.05a.458.458 0 0 1-.525.744l-1.957-1.118-.287 2.015a.577.577 0 0 1-1.142 0l-.288-2.015-1.956 1.118a.458.458 0 0 1-.525-.745l2.388-2.049.297-4.184-3.473 2.351-.578 3.093a.46.46 0 0 1-.909-.082l-.01-2.254-1.888.76a.577.577 0 0 1-.571-.99l1.6-1.257-1.945-1.135a.458.458 0 0 1 .383-.827l2.966 1.044 3.774-1.834-3.774-1.833-2.966 1.045a.458.458 0 0 1-.383-.827l1.945-1.136-1.6-1.256a.577.577 0 0 1 .57-.99l1.889.759.01-2.253a.458.458 0 0 1 .909-.082l.578 3.092 3.472 2.35-.296-4.183L8.66 4.637a.459.459 0 0 1 .525-.745l1.956 1.117.288-2.014A.58.58 0 0 1 12 2.5" />
    </svg>
);
